import { Component, inject, OnInit, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfigService } from '../../services/config.service';

type LandingPage = 'home' | 'institucion' | 'ayuda';

@Component({
  selector: 'app-aula-madrid-landing',
  templateUrl: './aula-madrid-landing.component.html',
  styleUrls: ['./aula-madrid-landing.component.scss']
})
export class AulaMadridLandingComponent implements OnInit {
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly configService = inject(ConfigService);
  private readonly router = inject(Router);

  readonly page = signal<LandingPage>('home');

  constructor() {
    this.activatedRoute.data.subscribe((data) => {
      this.page.set(data.page);
    });

    if (!this.configService.isAulaMadrid()) {
      this.router.navigate(['/']);
    }
  }

  ngOnInit() {
    window.sessionStorage.setItem('aula-madrid-login', 'true');
  }
}
